import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, CircularProgress } from '@mui/material';

interface StepperRightButtonProps {
  activeStep: number;
  steps: string[];
  isSaving: boolean;
  onClick: () => void;
  classes: any;
  disabled?: boolean;
}

const StepperRightButton: React.FC<StepperRightButtonProps> = ({
  activeStep,
  steps,
  isSaving,
  onClick,
  classes,
  disabled
}) => (
  <Button
    disableElevation
    className={classes.buttonSecondary}
    disabled={disabled || false}
    endIcon={isSaving ? null : <ChevronRightIcon />}
    onClick={onClick}
    style={{ minWidth: 130 }}
  >
    {isSaving ? (
      <CircularProgress color="inherit" size={20} />
    ) : activeStep + 1 === steps.length ? (
      'Submit'
    ) : (
      'Next'
    )}
  </Button>
);

export default StepperRightButton;
